<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitre }}
              </h1>
              <app-breadcrumb v-if="idRemiseBancaire" :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <b-checkbox class="mgr-10px" v-model="addOther" v-if="!isModification">
              {{$t('remiseBancaire.ajoutReglement.ajouterUnAutre')}}
            </b-checkbox>
            <a class="button" @click="annuler">
              {{$t('remiseBancaire.ajoutReglement.annuler')}}
            </a>
            <a class="button is-addOrEdit" @click="sauvegardeReglement()">
              {{$t('general.button.sauvegarder')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <br>
    <error-msg-component :messages="messages"
                          :error="error"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          @close="error = $event"/>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('remiseBancaire.ajoutReglement.informationRemiseBancaire') }}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <b-field :label="$t('remiseBancaire.ajoutReglement.banque')"
                   class="column is-2" v-if="remiseBancaire.domiciliationBancaire">
            <p>{{ remiseBancaire.domiciliationBancaire.libelle }}</p>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.modeReglement:')"
                   class="column is-2" v-if="remiseBancaire.modeReglement">
            <p>{{ remiseBancaire.modeReglement.libelle }}</p>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{getSousTitre}}</p>
      </header>
      <div class="card-content">
        <b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.clientOuCompteComptable')"
                   class="column is-3">
            <b-autocomplete icon="magnify" v-model="infoClient.client"
                            field="nomCommercialAvecVille"
                            :data="infoClient.dataAutoComplete"
                            @input="getClientASyncAndReloadFacture()"
                            @select="item => selectClient(item)" :disabled="isModification">
            </b-autocomplete>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.numeroFacture')"
                   class="column is-3">
            <b-autocomplete icon="magnify" v-model="infoFacture.facture" field="code"
                            :data="dataFacture" @input="getFactureASyncAndReloadClient()"
                            @select="item => selectFacture(item)" :disabled="isModification">
            </b-autocomplete>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.nomTire')"
                   class="column">
            <b-input v-model="paramReglement.emetteur"></b-input>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.montantTtc')"
                   class="obligatoire column">
            <input-currency :value="paramReglement.montantTtc"
                            @input="checkMontantTtc"
                            isNumber="true"
                            :disabled="remiseValidee">
            </input-currency>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.referenceTire')"
                   class="column">
            <b-input v-model="paramReglement.referenceReglement"></b-input>
          </b-field>
        </b-field>
        <b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.dateReglement')"
                   class="column obligatoire is-3">
            <b-datepicker show-week-number
              nearby-selectable-month-days
              icon="calendar-today"
              v-model="dateReglementTmp"
              :editable="true">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('remiseBancaire.ajoutReglement.dateEffet')"
                   class="column is-3">
            <b-datepicker show-week-number
              icon="calendar-today"
              nearby-selectable-month-days
              v-model="dateEffetTmp"
              :editable="true">
            </b-datepicker>
          </b-field>
        </b-field>
      </div>
    </div>
    <div v-if="dataTable.length > 0" class="mgt-20px">
      <b-field class="column is-3 card mgt-20px">
        <router-link
          :target="checkPermissions(permsTiers.lecture) ? '_blank' : ''"
          :to="{ name: 'c.bodac.clients/contacts-enCours', params:{ id: paramReglement.tiersId }}"
          :class="{ 'text-access-no-permission': !checkPermissions(permsTiers.lecture)}">
          <div class="level">
            <div class="level-left">{{ $t('remiseBancaire.ajoutReglement.soldeAu',
              { date: formatDate(new Date()) }) }}
            </div>
            <div class="level-right" :class="getColorOfSolde">
              {{ soldeTiersId | formatDevise }}
            </div>
          </div>
        </router-link>
      </b-field>
      <b-field>
        <b-field class="column is-3 card has-text-centered">
          <div class="level">
            <div class="level-left">
              <b-icon :icon="getIcon" class="" :type="getType"></b-icon>
            </div>
            <div class="level-right">
              <span :class="getClassColor" class="mgl-30px">
            {{ this.totalLetterage | formatDevise }}
             /
            {{ this.paramReglement.montantTtc ? this.paramReglement.montantTtc : 0 | formatDevise }}
          </span>
            </div>
          </div>
        </b-field>
      </b-field>
      <b-table :data="dataTable" :bordered="true" :striped="true">
        <b-table-column field="facture"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.facture')">
          <router-link-blank
            :to="{ name: 'c.bodac.factures', params: { id: props.row.idFacture }}"
            :message="props.row.libelle"
          />
        </b-table-column>
        <b-table-column field="type"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.type')">
            <span>{{ props.row.type === 'remiseBancaire.ajoutReglement.facture' ?
              $t('remiseBancaire.ajoutReglement.facture') : props.row.type }}</span>
        </b-table-column>
        <b-table-column field="modeReglement"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.modeReglement')">
          <span v-if="props.row.modeReglement">{{ props.row.modeReglement.libelle }}</span>
        </b-table-column>
        <b-table-column field="dateEcheance"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.dateEcheance')">
          <span>{{props.row.dateEcheance}}</span>
        </b-table-column>
        <b-table-column field="montant"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.montant')"
                        class="right">
          <span>{{props.row.montant | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="montantRestant"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.montantRestantTtc')"
                        class="right">
          <b-field position="is-right">
          <span>
            {{props.row.montantRestant | formatDevise}}</span>
            <div @click="assignAmount(props.row)">
              <b-icon icon="arrow-expand-right" type="is-primary"
                      class="mgl-10px is-cursor-pointer"></b-icon>
            </div>
          </b-field>
        </b-table-column>
        <b-table-column field="inputLetterage"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.inputLetterage')">
          <input-currency v-model="props.row.inputLetterage" :value="props.row.inputLetterage"
                          isNumber="true" @input="calculateSolde(props.row)">
          </input-currency>
        </b-table-column>
        <b-table-column field="solde"
                        v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.solde')"
                        class="right">
          <span>{{props.row.solde | formatDevise}}</span>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import miseEnFormeDuTableauDesEcheances from '@/services/remiseBancaire/miseEnFormeTableauLettrages';
import {
  ETAT_ENREGISTRE, SOUS_TYPE_NORMAL, SOUS_TYPE_ACOMPTE, TYPE_FACTURE, SENS_VENTE,
} from '@/configuration/devisConf';
import gestionDateBase from '@/services/general/gestionDateBase';
import { TIERS } from '@/configuration/permissionsBodacConf';
import inputCurrency from '@/components/general/inputCurrency';
import validationReglement from '@/services/reglement/validation/validationReglement';
import genererTableauDesLettragesModification from '@/services/remiseBancaire/initLettragesModification';
import breadcrumb from '@/components/general/breadcrumb';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { sauvegarde } from '@/api/lettrage/index';
import genererReglement from '@/services/reglement/genererReglement';
import formatIsoDate from '@/services/general/formatIsoDate';
import { getAll as getAllTiers } from '@/api/tiers/index';
import preparationDesLettrages from '@/services/lettrages/preparationDesLettrages';
import { get as getMouvementClient, getAll as getAllMouvementClient, getSolde } from '@/api/mouvementClient/index';
import { getAll as getAllFacture } from '@/api/facture/index';
import { get as getRemiseBancaire } from '@/api/remiseBancaire/index';
import { get as getReglement, create as createReglement, update as updateReglement } from '@/api/reglement/index';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import miseEnFormeAddresseClient from '@/services/reglement/miseEnFormeAddresseClient';
import stockInformationModificationInReglement from '@/services/reglement/stockInformationModificationInReglement';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import calculArrondi from '@/services/calcul/calculArrondi';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import formatDate from '@/services/general/formatDate';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import * as remiseConf from '@/configuration/remiseBancaire/remiseBancaireConf';
import messageInfo from '@/services/general/messageInformation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/reglement/validation/champsReglementTranslator';

const societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'ajoutModificationReglement',
  data() {
    return {
      dataTable: [],
      addOther: true,
      infoClient: {
        client: '',
        clientSelected: null,
        dataAutoComplete: [],
      },
      infoFacture: {
        facture: '',
        factureSelected: null,
      },
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      dateReglementTmp: null,
      dateEffetTmp: null,
      error: false,
      tiersId: null,
      totalLetterage: 0,
      mouvement: [],
      dataFacture: [],
      paramReglement: genererReglement(),
      remiseBancaire: {},
      dataModification: [],
      idRemiseBancaire: null,
      idReglement: null,
      reglementIsSave: null,
      soldeTiersId: null,
      montantReglementInitial: null,
      permsTiers: TIERS,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    routerLinkBlank,
    inputCurrency,
    errorMsgComponent,
  },
  methods: {
    checkMontantTtc(newMontant) {
      this.paramReglement.montantTtc = newMontant;
      if (!this.isModification || newMontant >= this.totalLetterage) {
        return;
      }
      this.dataTable.forEach((ligne) => {
        ligne.inputLetterage = 0;
        this.calculateSolde(ligne);
      });
      messageInfo(this.$i18n.t('remiseBancaire.ajoutReglement.info.montantTtcChange'));
    },
    getTiersId(client, facture) {
      if (client === null && facture === null) return null;
      if (facture === null) return client.id;
      let tiersId = null;
      facture.intervenants.forEach((intervenant) => {
        if (intervenant.payeur === true) tiersId = intervenant.tiersId;
      });
      return tiersId;
    },
    async getSoldeOfTiersId() {
      const param = {
        tiersId: this.paramReglement.tiersId,
        date: formatIsoDate(new Date()),
      };
      this.soldeTiersId = (await getSolde(param)).data.result;
    },
    getClientASyncAndReloadFacture: debounce(async function loadData() {
      this.infoFacture.facture = '';
      if ((this.infoClient.clientSelected
        && this.infoClient.clientSelected.nomCommercialAvecVille === this.infoClient.client)
        || this.isModification) {
        return;
      }
      this.totalLetterage = 0;
      this.infoFacture.factureSelected = null;
      this.mouvement = [];
      this.dataTable = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.infoClient.client.length > 0) {
          const query = {
            query: {
              nomCommercialCompteComptable: this.infoClient.client,
              societeId: this.societeActiveId,
              type: tiersConf.TIERS_TYPE_CLIENT,
              sousType: [tiersConf.TIERS_SOUS_TYPE_AUCUN],
            },
          };
          const dataClient = await getAllTiers(query);
          await this.modificationAutoComplete(dataClient.data.result);
        }
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      this.infoClient.clientSelected = null;
    }, 500),
    async selectClient(client) {
      if (client === null) return;
      this.infoClient.clientSelected = client;
      const parameters = {
        etatLettrage: ['NonLettre', 'LettrePartiellement'],
        debit: this.paramReglement.montantTtc >= 0,
        brouillard: false,
        tiersId: await this.getTiersId(client, null),
        societeId: this.societeActiveId,
      };
      this.paramReglement.tiersId = await this.getTiersId(this.infoClient.clientSelected,
        this.infoFacture.factureSelected);
      await this.getSoldeOfTiersId();
      this.dataTable = await this.getEcheance(parameters);
    },
    getFactureASyncAndReloadClient: debounce(async function loadData() {
      this.infoClient.client = '';
      if (this.infoFacture.factureSelected
        && this.infoFacture.factureSelected.code === this.infoFacture.facture) {
        return;
      }
      this.infoFacture.factureSelected = null;
      this.totalLetterage = 0;
      this.mouvement = [];
      this.dataTable = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.infoFacture.facture.length > 0) {
          const tmp = await getAllFacture({
            query:
              {
                code: this.infoFacture.facture,
                societeId: this.societeActiveId,
                sousType: [SOUS_TYPE_NORMAL, SOUS_TYPE_ACOMPTE],
                type: TYPE_FACTURE,
                sens: SENS_VENTE,
                etat: [ETAT_ENREGISTRE],
              },
          });
          this.dataFacture = tmp.data.result.items;
        }
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      this.infoFacture.factureSelected = null;
    }, 500),
    async selectFacture(facture) {
      if (facture === null) return;
      this.infoFacture.factureSelected = facture;
      const param = {
        etatLettrage: ['NonLettre', 'LettrePartiellement'],
        factureId: facture.id,
        debit: this.paramReglement.montantTtc >= 0,
        brouillard: false,
        societeId: this.societeActiveId,
      };
      this.paramReglement.tiersId = await this.getTiersId(this.infoClient.clientSelected,
        this.infoFacture.factureSelected);
      await this.getSoldeOfTiersId();
      this.dataTable = await this.getEcheance(param);
    },
    async getEcheance(query) {
      const loadingComponent = this.$buefy.loading.open();
      let infoMouvement = [];
      try {
        const objectFilter = {
          query: query,
          MaxResultCount: 9999,
          SkipCount: 0,
          societeId: this.societeActiveId,
        };
        const response = await getAllMouvementClient(objectFilter);
        this.mouvement = response.data.result.items;
        infoMouvement = await miseEnFormeDuTableauDesEcheances(this.mouvement);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      return infoMouvement;
    },
    async preparationEtAjoutDesLettrage(idReglement) {
      const allLettrages = preparationDesLettrages(this.dataTable, idReglement);
      if (allLettrages.lettrages.length > 0) {
        await sauvegarde(allLettrages);
      }
    },
    async sauvegardeReglement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.paramReglement.dateReglement = cloneDeep(formatIsoDate(this.dateReglementTmp));
        this.paramReglement.dateEffet = cloneDeep(formatIsoDate(this.dateEffetTmp));
        let response = null;
        if (!this.isModification) {
          response = await createReglement(this.paramReglement);
          this.reglementIsSave = response.data.result.id;
        }
        if (this.isModification) {
          if (this.montantReglementInitial !== this.paramReglement.montantTtc
            && this.montantReglementInitial !== null) {
            const allLettragesADelettrer = preparationDesLettrages(
              this.dataTable,
              this.paramReglement.id,
            );
            allLettragesADelettrer.lettrages.forEach(lettrage => {
              lettrage.montant = 0;
            });
            await sauvegarde(allLettragesADelettrer);
            this.dataTable.forEach(lettrage => {
              delete lettrage.idLettrage;
            });
          }
          response = await updateReglement(this.paramReglement);
        }
        await this.preparationEtAjoutDesLettrage(response.data.result.id);
        if (this.isModification) {
          messageSucces(this.$t('remiseBancaire.messages.successEditReglement'));
        } else messageSucces(this.$t('remiseBancaire.messages.successAddReglement'));
        this.error = false;
        if (this.addOther && !this.isModification) {
          this.reLoadValue();
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        this.$router.go(-1);
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          if (this.reglementIsSave !== null) {
            this.$router.push({ name: 'm.bodac.remises_bancaires-edition', params: { idReglement: this.reglementIsSave, erreur: true } });
            return;
          }
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        throw (e);
      }
    },
    async calculateSolde(echeance) {
      if (echeance.inputLetterage === null) {
        echeance.inputLetterage = 0;
        echeance.solde = echeance.soldeSave;
      }
      if (echeance.inputLetterage >= echeance.soldeSave) {
        echeance.inputLetterage = echeance.soldeSave;
        echeance.solde = 0;
      } else {
        echeance.solde = echeance.soldeSave - echeance.inputLetterage;
      }
      await this.calculAllLettrage();
    },
    async assignAmount(informationLettrage) {
      if (this.totalLetterage > this.paramReglement.montantTtc
        && informationLettrage.inputLetterage === 0) { return; }
      if (informationLettrage.solde > (this.paramReglement.montantTtc - this.totalLetterage)) {
        informationLettrage.inputLetterage += this.paramReglement.montantTtc - this.totalLetterage;
        informationLettrage.solde -= this.paramReglement.montantTtc - this.totalLetterage;
      } else {
        informationLettrage.inputLetterage += informationLettrage.solde;
        informationLettrage.solde = 0;
      }
      await this.calculAllLettrage();
    },
    async reLoadValue() {
      this.infoClient.client = '';
      this.infoClient.clientSelected = null;
      this.infoFacture.facture = '';
      this.infoFacture.factureSelected = null;
      this.paramReglement = genererReglement();
      this.paramReglement.remiseBancaireId = this.idRemiseBancaire;
      const tmp = await getRemiseBancaire(this.paramReglement.remiseBancaireId);
      this.remiseBancaire = tmp.data.result;
      this.dateReglementTmp = gestionDateBase(this.remiseBancaire.dateRemise);
      this.dateEffetTmp = null;
      this.dataTable = [];
    },
    modificationAutoComplete(dataClient) {
      this.infoClient.dataAutoComplete = [];
      dataClient.items.forEach((client) => {
        client.nomCommercialAvecVille = client.code + ' - ' + client.nomCommercial + ' - ' + adressFullStringGetter(client.adressePostale, false);
        if (client.compteComptable) {
          client.nomCommercialAvecVille += ' - ' + client.compteComptable;
        }
        this.infoClient.dataAutoComplete.push(client);
      });
    },
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationReglement(response, this.messages);
      validationGeneral(this.$i18n, response, this.champsVide,
        this.messages, this.messagesChampsVide, translate);
      this.error = true;
    },
    annuler() {
      this.$router.go(-1);
    },
    formatDate(data) {
      return formatDate(data);
    },
    calculAllLettrage() {
      this.totalLetterage = 0;
      this.dataTable.forEach((line) => {
        line.inputLetterage = parseFloat(calculArrondi(line.inputLetterage));
        this.totalLetterage += parseFloat(line.inputLetterage);
      });
      return this.totalLetterage;
    },
    async initVariablePourModification() {
      this.paramReglement = stockInformationModificationInReglement(
        this.paramReglement, this.dataModification,
      );
      this.infoClient.client = miseEnFormeAddresseClient(this.dataModification);
      this.dateEffetTmp = gestionDateBase(
        this.dataModification.ligneRemiseBancairePseudoEntity.dateEffet,
      );
      const parameters = {
        etatLettrage: ['NonLettre', 'LettrePartiellement'],
        debit: this.paramReglement.montantTtc >= 0,
        brouillard: false,
        tiersId: this.dataModification.tiersId,
        societeId: this.societeActiveId,
      };
      const infoMouvement = await this.getEcheance(parameters);
      this.dataTable = await genererTableauDesLettragesModification(this.dataModification.lettrages,
        this.dataModification.id, infoMouvement);
      await this.calculAllLettrage();
      await this.getSoldeOfTiersId();
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getColorOfSolde() {
      if (!this.checkPermissions(this.permsTiers.lecture)) return 'text-access-no-permission';
      if (this.soldeTiersId < 0) return 'has-text-danger';
      if (this.soldeTiersId > 0) return 'has-text-success';
      return 'has-text-default';
    },
    getIcon() {
      if (this.totalLetterage > this.paramReglement.montantTtc) return 'alert';
      if (parseInt(this.totalLetterage, 10) === parseInt(this.paramReglement.montantTtc, 10)
        && this.paramReglement.montantTtc !== 0) {
        return 'check-circle';
      }
      return '';
    },
    getClassColor() {
      if (this.paramReglement.montantTtc === null && this.totalLetterage !== 0) return 'has-text-danger';
      if (this.totalLetterage > this.paramReglement.montantTtc) return 'has-text-danger';
      return '';
    },
    remiseValidee() {
      return this.remiseBancaire.etat === remiseConf.VALIDE;
    },
    isModification() {
      if (this.idReglement === undefined || this.idReglement === null) {
        return false;
      }
      return true;
    },
    getType() {
      if (this.totalLetterage > this.paramReglement.montantTtc) return 'is-warning';
      if (parseInt(this.totalLetterage, 10) === parseInt(this.paramReglement.montantTtc, 10) && this.paramReglement.montantTtc !== 0) return 'is-success';
      return '';
    },
    getTitre() {
      return !this.isModification ? this.$t('remiseBancaire.ajoutReglement.titre')
        : this.$t('remiseBancaire.ajoutReglement.titreModification');
    },
    getSousTitre() {
      return !this.isModification ? this.$t('remiseBancaire.ajoutReglement.titre')
        : this.$t('remiseBancaire.ajoutReglement.titreModification');
    },
    breadcrumb() {
      const output = [
        { title: this.$t('remiseBancaire.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('remiseBancaire.titre'), route: { name: 'l.bodac.remises_bancaires' }, isActive: false },
        {
          title: formatCodeRemiseBancaire(this.remiseBancaire.num,
            this.remiseBancaire.nom, SENS_VENTE),
          route: { name: 'c.bodac.remises_bancaires', params: { id: this.idRemiseBancaire } },
          isActive: false,
        },
        { title: this.getTitre, isActive: true },
      ];
      return output;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.idRemiseBancaire = this.$route.params.idRemiseBancaire;
    this.idReglement = this.$route.params.idReglement;
    if (this.$route.params.erreur === true) {
      this.error = true;
      this.messages.push({
        message: 'remiseBancaire.ajoutReglement.montantInferieur',
      });
    }
    try {
      if (this.idRemiseBancaire === null || this.idRemiseBancaire === undefined) {
        const reglementData = await getReglement(this.$route.params.idReglement);
        this.idRemiseBancaire = reglementData.data.result.remiseBancaireId;
        this.montantReglementInitial = reglementData.data.result.montantTtc;
      }
      const tmp = await getRemiseBancaire(this.idRemiseBancaire);
      this.remiseBancaire = tmp.data.result;
      this.paramReglement.remiseBancaireId = this.idRemiseBancaire;
      this.dateReglementTmp = gestionDateBase(this.remiseBancaire.dateRemise);
      if (this.isModification) {
        const tmp = await getMouvementClient(this.idReglement);
        this.dataModification = tmp.data.result;
        this.paramReglement.id = this.dataModification.id;
        await this.initVariablePourModification();
        this.montantReglementInitial = this.paramReglement.montantTtc;
        this.setInformationPage(this.$t('pageGescom.remiseBancaire.modififcationReglement'));
      } else this.setInformationPage(this.$t('pageGescom.remiseBancaire.creationReglement'));
      loadingComponent.close();
    } catch (e) {
      if (e.response.data.error) {
        this.loadError(e.response);
      } else {
        messageErreur(this.$i18n);
      }
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
